import 'quasar/src/css/index.sass';
import './styles/quasar.sass';
import '@quasar/extras/roboto-font/roboto-font.css';
import '@quasar/extras/material-icons/material-icons.css';
import {
  Meta,
  Notify,
  Loading,
  LoadingBar,
  LocalStorage,
  Cookies,
  Dialog,
  AppFullscreen
} from 'quasar';

const quasarUserOptions = {
  config: {},
  plugins: {
    Meta,
    Notify,
    Loading,
    LoadingBar,
    LocalStorage,
    Cookies,
    Dialog,
    AppFullscreen
  }
};

Notify.setDefaults({
  position: 'top-right',
  progress: true,
  timeout: 2500,
  actions: [
    {
      icon: 'close',
      color: 'white',
      round: true,
      'aria-label': 'Close'
    }
  ]
});

LoadingBar.setDefaults({
  color: 'positive',
  size: '5px',
  position: 'top'
});

export default quasarUserOptions;
